import {storage} from "../utils/localstorage";
import {AppComponent} from "../App";

export const post = async (method, data) => {
    const res = await fetch(`https://mathem.org/adminData/${method}`, {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({
            adminKey: storage("adminKey"), ...data,
            minutesOffset: new Date().getTimezoneOffset()
        }),
    });

    const response = await res.json();

    if (response.forbidden) {
        return AppComponent.adminForbidden(true);
    }

    return response
}
